var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "tab-vessel-eq", attrs: { id: "tabVesselEq" } },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "row" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.showBookingEdi1 && _vm.showButton) ||
                        !_vm.readonly,
                      expression: "(showBookingEdi1 && showButton) || !readonly"
                    }
                  ],
                  staticClass: "section"
                },
                [
                  _c("div", { staticClass: "operations" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cooperateEdit,
                            expression: "cooperateEdit"
                          }
                        ],
                        staticClass: "triggers"
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-menu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.showBookingEdi1 && _vm.showButton,
                                    expression: "showBookingEdi1 && showButton"
                                  }
                                ],
                                staticClass:
                                  "el-menu-button el-button el-button--primary el-button--mini",
                                staticStyle: {
                                  width: "90px",
                                  "vertical-align": "top"
                                },
                                attrs: {
                                  "text-color": "#404144",
                                  "active-text-color": "#404144",
                                  mode: "horizontal"
                                },
                                on: { select: _vm.toBookingPre }
                              },
                              [
                                _c(
                                  "el-submenu",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.bookingEdi1Disabled ||
                                        !(
                                          _vm.action === "look" && _vm.form.uuid
                                        ),
                                      index: "index"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "el-menu-btn-text",
                                        attrs: { slot: "title" },
                                        slot: "title"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.EDIBooking"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-submenu",
                                      { attrs: { index: "original" } },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.Original"))
                                          )
                                        ]),
                                        _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "API0",
                                              disabled:
                                                !_vm.bookingEDIApiOpen &&
                                                !_vm.isHZ
                                            }
                                          },
                                          [_vm._v("API")]
                                        ),
                                        _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "FTP1",
                                              disabled: _vm.isHZ
                                            }
                                          },
                                          [_vm._v("FTP")]
                                        ),
                                        _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "RPA1",
                                              disabled: _vm.isHZ
                                            }
                                          },
                                          [_vm._v("RPA")]
                                        )
                                      ],
                                      2
                                    ),
                                    _c(
                                      "el-submenu",
                                      { attrs: { index: "correct" } },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.Correct"))
                                          )
                                        ]),
                                        _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "FTP0",
                                              disabled: _vm.isHZ
                                            }
                                          },
                                          [_vm._v("FTP")]
                                        ),
                                        _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "API1",
                                              disabled:
                                                !_vm.bookingEDIApiOpen ||
                                                _vm.isHZ
                                            }
                                          },
                                          [_vm._v("API")]
                                        )
                                      ],
                                      2
                                    ),
                                    _c(
                                      "el-submenu",
                                      { attrs: { index: "shutOut" } },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.ShutOut"))
                                          )
                                        ]),
                                        _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "FTP2",
                                              disabled: _vm.isHZ
                                            }
                                          },
                                          [_vm._v("FTP")]
                                        ),
                                        _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "API2",
                                              disabled: !_vm.isHZ
                                            }
                                          },
                                          [_vm._v("API")]
                                        )
                                      ],
                                      2
                                    ),
                                    _vm.seAllowReceiptImport
                                      ? _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: _vm.$t(
                                                "SeaExport.ReceiptImport"
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.ReceiptImport"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "can-operate",
                                attrs: { no: "1", type: "primary" },
                                on: { click: _vm.loadBookingLog }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_BookingLog"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !_vm.readonly &&
                                      [1, 2, 3].includes(_vm.isInputMbl),
                                    expression:
                                      "!readonly && [1, 2, 3].includes(isInputMbl)"
                                  },
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: ["button_SEBooking_generateMBL"],
                                    expression:
                                      "['button_SEBooking_generateMBL']"
                                  }
                                ],
                                attrs: { no: "2", type: "primary" },
                                on: { click: _vm.generateMblNo }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.GeneratePrimaryDocNo")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !_vm.readonly &&
                                      _vm.form.mbl &&
                                      [1, 2, 3].includes(_vm.isInputMbl),
                                    expression:
                                      "!readonly && form.mbl && [1, 2, 3].includes(isInputMbl)"
                                  },
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: ["button_SEBooking_generateSoNo"],
                                    expression:
                                      "['button_SEBooking_generateSoNo']"
                                  }
                                ],
                                attrs: { no: "3", type: "primary" },
                                on: { click: _vm.generateSoNo }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.AddSpellCustomsOrderNo")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.readonly &&
                                      _vm.form.mbl &&
                                      _vm.form.masterFlag &&
                                      [1, 2, 3].includes(_vm.isInputMbl),
                                    expression:
                                      "readonly && form.mbl && form.masterFlag && [1, 2, 3].includes(isInputMbl)"
                                  },
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: ["button_SEBooking_generateMBL"],
                                    expression:
                                      "['button_SEBooking_generateMBL']"
                                  }
                                ],
                                attrs: { no: "4", type: "primary" },
                                on: { click: _vm.allocateSoNo }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.DistributionCustomsNo")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.enableShipperConsignNotify,
                                    expression: "enableShipperConsignNotify"
                                  }
                                ],
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "shipperLock",
                                  disabled: _vm.enableShipperLock
                                },
                                model: {
                                  value: _vm.form.shipperLock,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipperLock", $$v)
                                  },
                                  expression: "form.shipperLock"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.ShipperLocked"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { "padding-left": "0" }
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.form.uuid &&
                            _vm.showResubscribeBookingReceipt &&
                            _vm.canSubscribeReceipt &&
                            [
                              _vm.SystemConstants
                                .JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS.code,
                              _vm.SystemConstants
                                .JOB_BOOKING_GET_BOOKING_RECEIPT_FAIL.code
                            ].indexOf(_vm.form.bookingState) > -1,
                          expression:
                            "form.uuid && showResubscribeBookingReceipt && canSubscribeReceipt && [SystemConstants.JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS.code, SystemConstants.JOB_BOOKING_GET_BOOKING_RECEIPT_FAIL.code].indexOf(form.bookingState) > -1"
                        }
                      ],
                      attrs: {
                        no: "resubscribeBookingReceipt",
                        type: "primary"
                      },
                      on: { click: _vm.subscribeReceiptExec }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_ResubscribeBookingReceipt")
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c("div", { staticStyle: { width: "fit-content" } }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "85px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.BookingInfo")))
                          ]),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showVessel,
                                  expression: "showVessel"
                                }
                              ],
                              attrs: {
                                label: _vm.$t("SeaExport.VesselAndVoyage")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "vesselAndVoyage",
                                  disabled: _vm.readonlyVessel
                                },
                                on: {
                                  input: function(value) {
                                    return _vm.pm.onVesselAndVoyageChange(value)
                                  }
                                },
                                model: {
                                  value: _vm.form.vesselAndVoyage,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "vesselAndVoyage", $$v)
                                  },
                                  expression: "form.vesselAndVoyage"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              class: _vm.fieldClass.vesselTitle,
                              attrs: { label: _vm.$t("SeaExport.Vessel") }
                            },
                            [
                              _c("cargo-advance-select", {
                                class: _vm.importDifferenceField.vessel
                                  ? _vm.fieldClass.vessel + " red-border"
                                  : _vm.fieldClass.vessel,
                                attrs: {
                                  no: "5",
                                  disabled: !_vm.pm
                                    .lclslaveEnabledExcludeExportToImport,
                                  "select-type":
                                    _vm.selectTypeNames.static_data_Vessel,
                                  cache: false,
                                  filterable: "",
                                  "allow-create": _vm.pm._allowEditingVessel,
                                  "default-value": _vm.form.vessel,
                                  "static-options": _vm.pm.vesselList
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.pm.onVesselSelectionChange(p)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              class: _vm.fieldClass.voyageFlightTitle,
                              attrs: { label: _vm.$t("SeaExport.Voyage") }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("cargo-advance-select", {
                                    ref: "voyageFlight",
                                    class: _vm.importDifferenceField
                                      .voyageFlight
                                      ? _vm.fieldClass.voyageFlight +
                                        " red-border"
                                      : _vm.fieldClass.voyageFlight,
                                    attrs: {
                                      no: "6",
                                      "static-options": _vm.pm._voyages || [],
                                      cache: false,
                                      "default-value": _vm.form.voyageFlight,
                                      disabled: !_vm.pm
                                        .lclslaveEnabledExcludeExportToImport,
                                      filterable: "",
                                      clearable: "",
                                      "allow-create":
                                        _vm.pm.editVoyageMode === 1,
                                      "tag-name": "voyageNo",
                                      "tag-value": "voyageNo",
                                      "filter-tag-names": ["voyageNo"]
                                    },
                                    on: {
                                      focus: function($event) {
                                        return _vm.pm.txtVoyageFocusInHandler()
                                      },
                                      parentCallBack: function(p) {
                                        _vm.pm.onVoyageFlightChange(p)
                                      }
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.isSelectVesselSchedule &&
                                            this.action !== "look",
                                          expression:
                                            "isSelectVesselSchedule && this.action !== 'look'"
                                        }
                                      ],
                                      staticClass:
                                        "el-button el-button--primary el-button--mini",
                                      staticStyle: {
                                        "min-width": "40px!important",
                                        "margin-left": "2px"
                                      },
                                      on: { click: _vm.btnVayageShowHandle }
                                    },
                                    [_c("i", { staticClass: "el-icon-search" })]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.CarrierVoyage")
                              }
                            },
                            [
                              _c("el-input", {
                                class: _vm.importDifferenceField.carrierVoyage
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled:
                                    _vm.readonlyExcludeExportToImport ||
                                    _vm.canEditInternalDelegatedJobField,
                                  no: "carrierVoyage"
                                },
                                model: {
                                  value: _vm.form.carrierVoyage,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "carrierVoyage", $$v)
                                  },
                                  expression: "form.carrierVoyage"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              class: _vm.fieldClass.soNoTitle,
                              attrs: { label: "S/O No." }
                            },
                            [
                              _c("so-no-input", {
                                class: _vm.fieldClass.soNo,
                                attrs: {
                                  disabled:
                                    _vm.readonlyExcludeExportToImport ||
                                    _vm.slaveCustomsDeclarationEnable
                                },
                                on: {
                                  blur: function($event) {
                                    return _vm.mblBlur(_vm.form.soNo, true)
                                  }
                                },
                                model: {
                                  value: _vm.form.soNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "soNo", $$v)
                                  },
                                  expression: "form.soNo"
                                }
                              })
                            ],
                            1
                          ),
                          !_vm.isSalesForSzfs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("SeaExport.MblNo2") }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "row",
                                        "padding-right": "3px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: [0, 2, 3].includes(
                                              _vm.isInputMbl
                                            ),
                                            expression:
                                              "[0, 2, 3].includes(isInputMbl)"
                                          }
                                        ],
                                        class:
                                          _vm.form.mbl === "CANCELLED"
                                            ? "mbl-red"
                                            : "",
                                        attrs: {
                                          no: "7",
                                          disabled:
                                            _vm.readonlyExcludeExportToImport
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.pm.changeMbl()
                                          },
                                          blur: _vm.mblBlur
                                        },
                                        model: {
                                          value: _vm.form.mbl,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "mbl", $$v)
                                          },
                                          expression: "form.mbl"
                                        }
                                      }),
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: [1].includes(_vm.isInputMbl),
                                            expression:
                                              "[1].includes(isInputMbl)"
                                          }
                                        ],
                                        class:
                                          _vm.form.mbl === "CANCELLED"
                                            ? "mbl-red"
                                            : "",
                                        attrs: {
                                          no: "8",
                                          disabled:
                                            _vm.readonlyExcludeExportToImport ||
                                            !_vm.mblEditable
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.mblConfig.curRule = null
                                          },
                                          change: function($event) {
                                            return _vm.pm.changeMbl()
                                          },
                                          blur: _vm.mblBlur
                                        },
                                        model: {
                                          value: _vm.form.mbl,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "mbl", $$v)
                                          },
                                          expression: "form.mbl"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          !_vm.isSalesForSzfs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.BookingNo")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled:
                                        _vm.readonlyExcludeExportToImport,
                                      no: "9"
                                    },
                                    model: {
                                      value: _vm.form.bookingNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "bookingNo", $$v)
                                      },
                                      expression: "form.bookingNo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isSalesForSzfs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ShippingCompanyContractNo"
                                    )
                                  }
                                },
                                [
                                  _vm.sCNumberSelectMethod === 0
                                    ? _c("el-input", {
                                        style: _vm.isTP
                                          ? "width: 75%;display: inline-block"
                                          : "",
                                        attrs: {
                                          no: "10",
                                          disabled:
                                            _vm.readonlyExcludeExportToImport,
                                          placeholder: _vm.$t(
                                            "common.defaultPlaceholder"
                                          )
                                        },
                                        model: {
                                          value: _vm.form.scNo,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "scNo", $$v)
                                          },
                                          expression: "form.scNo"
                                        }
                                      })
                                    : _vm.sCNumberSelectMethod === 1
                                    ? _c("cargo-advance-select", {
                                        ref: "scNoSelect",
                                        style: _vm.isTP
                                          ? "width: 75%;display: inline-block"
                                          : "",
                                        attrs: {
                                          no: "10",
                                          filterable: "",
                                          "allow-create": false,
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_ShippingContract,
                                          "static-options":
                                            _vm.shippingContractList,
                                          "tag-value": "contractNumber",
                                          "default-value": _vm.form.scNo,
                                          disabled:
                                            _vm.readonlyExcludeExportToImport,
                                          placeholder: _vm.$t(
                                            "common.defaultPlaceholder"
                                          )
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            _vm.pm.onscNoChange(p)
                                          }
                                        }
                                      })
                                    : _c("cargo-advance-select", {
                                        ref: "scNoSelect",
                                        style: _vm.isTP
                                          ? "width: 75%;display: inline-block"
                                          : "",
                                        attrs: {
                                          no: "10",
                                          filterable: "",
                                          "allow-create": true,
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_ShippingContract,
                                          "static-options":
                                            _vm.shippingContractList,
                                          "tag-value": "contractNumber",
                                          "default-value": _vm.form.scNo,
                                          disabled:
                                            _vm.readonlyExcludeExportToImport,
                                          placeholder: _vm.$t(
                                            "common.defaultPlaceholder"
                                          )
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            _vm.pm.onscNoChange(p)
                                          }
                                        }
                                      }),
                                  _vm.isTP
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: {
                                            width: "25%",
                                            display: "inline-block"
                                          },
                                          attrs: {
                                            disabled:
                                              _vm.readonlyExcludeExportToImport,
                                            no: "flashPointUnit",
                                            placeholder: ""
                                          },
                                          model: {
                                            value: _vm.form.scNoType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "scNoType",
                                                $$v
                                              )
                                            },
                                            expression: "form.scNoType"
                                          }
                                        },
                                        _vm._l(_vm.scNoTypeArray, function(
                                          item,
                                          index
                                        ) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: _vm.isZh
                                                ? item.chineseName
                                                : item.englishName,
                                              value: item.code
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isSalesForSzfs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.InnerContractNo")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    ref: "contractNo",
                                    class: _vm.importDifferenceField.contractNo
                                      ? _vm.fieldClass.contractNo +
                                        " red-border"
                                      : _vm.fieldClass.contractNo,
                                    attrs: {
                                      no: "11",
                                      "static-options":
                                        _vm.availableContractNos,
                                      cache: false,
                                      "default-value": _vm.form.contractNo,
                                      disabled:
                                        _vm.readonlyExcludeExportToImport ||
                                        !_vm.pm
                                          .lclslaveEnabledExcludeExportToImport,
                                      filterable: "",
                                      clearable: "",
                                      "allow-create": true,
                                      "tag-name": "contractNo",
                                      "tag-value": "contractNo",
                                      "filter-tag-names": ["contractNo"]
                                    },
                                    on: {
                                      parentCallBack: _vm.onContractNoChange
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.quotationNum") }
                            },
                            [
                              _c("el-input", {
                                class: _vm.importDifferenceField.quotationNum
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: _vm.readonlyExcludeExportToImport,
                                  no: "12"
                                },
                                model: {
                                  value: _vm.form.quotationNum,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "quotationNum", $$v)
                                  },
                                  expression: "form.quotationNum"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "IMO" } },
                            [
                              _c("el-input", {
                                class: _vm.importDifferenceField.vesselIMO
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: _vm.readonlyExcludeExportToImport,
                                  no: "13"
                                },
                                model: {
                                  value: _vm.form.vesselIMO,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "vesselIMO", $$v)
                                  },
                                  expression: "form.vesselIMO"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_CarrierCode")
                              }
                            },
                            [
                              _c("el-input", {
                                class: _vm.importDifferenceField.carrierCode
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: _vm.readonlyExcludeExportToImport,
                                  no: "carrierCode"
                                },
                                model: {
                                  value: _vm.form.carrierCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "carrierCode", $$v)
                                  },
                                  expression: "form.carrierCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.BookingShipCallSign")
                              }
                            },
                            [
                              _c("el-input", {
                                class: _vm.importDifferenceField.vesselCode
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  no: "14",
                                  disabled:
                                    _vm.readonlyExcludeExportToImport ||
                                    !_vm.pm.lclslaveEnabledExcludeExportToImport
                                },
                                model: {
                                  value: _vm.form.vesselCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "vesselCode", $$v)
                                  },
                                  expression: "form.vesselCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AirlineCode")
                              }
                            },
                            [
                              _c("el-input", {
                                class: _vm.importDifferenceField.routeCode
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  no: "95",
                                  disabled:
                                    _vm.checkRouteCode ||
                                    _vm.readonly ||
                                    !_vm.pm.lclslaveEnabledExcludeExportToImport
                                },
                                model: {
                                  value: _vm.form.routeCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "routeCode", $$v)
                                  },
                                  expression: "form.routeCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "CNPT No." } },
                            [
                              _c(
                                "special-character-tip",
                                {
                                  attrs: { texts: _vm.specialCharCheck.cNptNo }
                                },
                                [
                                  _c("cargo-repeat-value-select", {
                                    attrs: {
                                      placeholder: "",
                                      no: "cNptNo",
                                      filterable: "",
                                      "allow-create": true,
                                      disabled:
                                        _vm.readonlyExcludeExportToImport,
                                      clearable: "",
                                      options: _vm.cNptList,
                                      "label-field": "no",
                                      "value-field": "no",
                                      "unique-field": "no",
                                      "match-of-repeat-value": _vm.matchOfCNpt
                                    },
                                    on: {
                                      change: _vm.cNptChangeHandler,
                                      handleBlur: _vm.cNptBlurHandler
                                    },
                                    model: {
                                      value: _vm.form.cNptNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "cNptNo", $$v)
                                      },
                                      expression: "form.cNptNo"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "special-character-tip",
                                {
                                  attrs: {
                                    texts: _vm.specialCharCheck.cNptName
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled:
                                        _vm.readonlyExcludeExportToImport,
                                      no: "cNptName",
                                      type: "textarea",
                                      rows: 3
                                    },
                                    model: {
                                      value: _vm.form.cNptName,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "cNptName", $$v)
                                      },
                                      expression: "form.cNptName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_CustomerReserveVoyage"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.readonlyExcludeExportToImport,
                                  no: "customerReserveVoyage"
                                },
                                model: {
                                  value: _vm.form.customerReserveVoyage,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "customerReserveVoyage",
                                      $$v
                                    )
                                  },
                                  expression: "form.customerReserveVoyage"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-form-item", { attrs: { label: "N/A" } }, [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "15",
                                    "static-options": _vm.pm.nacList || [],
                                    cache: false,
                                    "default-value": _vm.form.na,
                                    disabled: _vm.readonlyExcludeExportToImport,
                                    filterable: "",
                                    clearable: "",
                                    "allow-create": true,
                                    "tag-name": "nac",
                                    "tag-value": "nac",
                                    "filter-tag-names": ["nac"]
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.na = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _c(
                            "el-form-item",
                            { attrs: { label: "NOVCC" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.readonlyExcludeExportToImport,
                                  no: "novcc"
                                },
                                model: {
                                  value: _vm.form.novcc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "novcc", $$v)
                                  },
                                  expression: "form.novcc"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "LINE CODE" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.readonlyExcludeExportToImport,
                                  no: "17"
                                },
                                model: {
                                  value: _vm.form.laneCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "laneCode", $$v)
                                  },
                                  expression: "form.laneCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.CarrierSpecificCode")
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("cargo-advance-select", {
                                    ref: "shippingCompanySpecificCode",
                                    class: _vm.importDifferenceField
                                      .shippingCompanySpecificCode
                                      ? _vm.fieldClass
                                          .shippingCompanySpecificCode +
                                        " red-border"
                                      : _vm.fieldClass
                                          .shippingCompanySpecificCode,
                                    attrs: {
                                      no: "shippingCompanySpecificCode",
                                      "static-options":
                                        _vm.shippingCompanySpecificCodeList,
                                      cache: false,
                                      "default-value":
                                        _vm.form.shippingCompanySpecificCode,
                                      disabled:
                                        _vm.readonlyExcludeExportToImport,
                                      filterable: "",
                                      clearable: "",
                                      "allow-create": true,
                                      "tag-name": "shippingCompanySpecificCode",
                                      "tag-value":
                                        "shippingCompanySpecificCode",
                                      "filter-tag-names": [
                                        "shippingCompanySpecificCode"
                                      ]
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.form.shippingCompanySpecificCode =
                                          p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.USAirlineInfo")))
                          ]),
                          _c(
                            "el-form-item",
                            { attrs: { label: "N/A CODE" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.readonlyExcludeExportToImport,
                                  no: "16"
                                },
                                model: {
                                  value: _vm.form.naCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "naCode", $$v)
                                  },
                                  expression: "form.naCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "CODE" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.readonlyExcludeExportToImport,
                                  no: "18"
                                },
                                model: {
                                  value: _vm.form.subContractNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "subContractNo", $$v)
                                  },
                                  expression: "form.subContractNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "TLI NO" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.readonlyExcludeExportToImport,
                                  no: "tliNo"
                                },
                                model: {
                                  value: _vm.form.tliNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "tliNo", $$v)
                                  },
                                  expression: "form.tliNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_IndiaLineInfo"))
                            )
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_CargoAmount")
                              }
                            },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  precision: 2,
                                  min: 0,
                                  disabled: _vm.readonlyExcludeExportToImport,
                                  no: "amount"
                                },
                                model: {
                                  value: _vm.form.amount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "amount", $$v)
                                  },
                                  expression: "form.amount"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_CargoCurrency")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "currency",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Currency,
                                  filterable: "",
                                  "default-value": _vm.form.currency,
                                  disabled: _vm.readonlyExcludeExportToImport
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.currency = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonlyExcludeExportToImport,
                        "label-width": "150px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.PolPortInfo")) + " ")
                      ]),
                      _c(
                        "el-form-item",
                        { staticClass: "warn-label" },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { display: "flex", float: "right" },
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm.shippingSchedules &&
                              _vm.shippingSchedules.length > 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        disabled: _vm.readonly,
                                        no: "showMoreShippingSchedules",
                                        type: "primary"
                                      },
                                      on: {
                                        click:
                                          _vm.showMoreShippingScheduleDialog
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_ChooseShippingSchedules"
                                          )
                                        ) + " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "10px" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.HarborDistrict"))
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("el-input", {
                            class: _vm.fieldClass.portDistrict,
                            attrs: {
                              no: "19",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid)
                            },
                            model: {
                              value: _vm.form.portDistrict,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "portDistrict", $$v)
                              },
                              expression: "form.portDistrict"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: { label: _vm.$t("SeaExport.CYOpeningTime") }
                        },
                        [
                          _c("el-date-picker", {
                            class: _vm.fieldClass.terminalOpendate,
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "20",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.terminalOpendate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "terminalOpendate", $$v)
                              },
                              expression: "form.terminalOpendate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.PortAreaCYCutOffTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            class: _vm.fieldClass.terminalCutoff,
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "21",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.terminalCutoff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "terminalCutoff", $$v)
                              },
                              expression: "form.terminalCutoff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CarrierCyCutOffTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            class: _vm.importDifferenceField.carrierCyCutOffTime
                              ? "red-border"
                              : "",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "22",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.carrierCyCutOffTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "carrierCyCutOffTime", $$v)
                              },
                              expression: "form.carrierCyCutOffTime"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.isXycw
                              ? _vm.$t("SeaExport.OriginalPlannedBerthingTime")
                              : _vm.$t("SeaExport.PlannedBerthingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            class: _vm.fieldClass.berthPlanDate,
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "23",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.berthPlanDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "berthPlanDate", $$v)
                              },
                              expression: "form.berthPlanDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.isXycw
                              ? _vm.$t("SeaExport.OriginalPlanDepartureTime")
                              : _vm.$t("SeaExport.PlanDepartureTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            class: _vm.fieldClass.unBerthPlanDate,
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "24",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.unBerthPlanDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "unBerthPlanDate", $$v)
                              },
                              expression: "form.unBerthPlanDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.isXycw
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.NowPlannedBerthingTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                class: _vm.fieldClass.berthPlanDate,
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "103",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.form.currentETA,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "currentETA", $$v)
                                  },
                                  expression: "form.currentETA"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isXycw
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.NowPlanDepartureTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                class: _vm.fieldClass.unBerthPlanDate,
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "104",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.form.currentETD,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "currentETD", $$v)
                                  },
                                  expression: "form.currentETD"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.ActualBerthingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            class: _vm.fieldClass.actualBerthPlanDate,
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "25",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.actualBerthPlanDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualBerthPlanDate", $$v)
                              },
                              expression: "form.actualBerthPlanDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.RealDepartureTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            class: _vm.fieldClass.actualUnBerthPlanDate,
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "26",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: {
                              input: _vm.actualUnBerthPlanDateChangeHandler
                            },
                            model: {
                              value: _vm.form.actualUnBerthPlanDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualUnBerthPlanDate", $$v)
                              },
                              expression: "form.actualUnBerthPlanDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PlannedDockingBerths")
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.fieldClass.berthPlanPlace,
                            attrs: {
                              no: "27",
                              disabled: Boolean(_vm.form.lclMasterUuid)
                            },
                            model: {
                              value: _vm.form.berthPlanPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "berthPlanPlace", $$v)
                              },
                              expression: "form.berthPlanPlace"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.TheActualDockingBerths")
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.fieldClass.actualBerthPlanPlace,
                            attrs: {
                              no: "28",
                              disabled: Boolean(_vm.form.lclMasterUuid)
                            },
                            model: {
                              value: _vm.form.actualBerthPlanPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualBerthPlanPlace", $$v)
                              },
                              expression: "form.actualBerthPlanPlace"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.ActualTimeOfArrivalThePort"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            class: _vm.fieldClass.realArrivalsDate,
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "29",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.realArrivalsDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "realArrivalsDate", $$v)
                              },
                              expression: "form.realArrivalsDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.EquipmentEstimatedReturnTimeFrom"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "30",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.returnPeriodBegin,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "returnPeriodBegin", $$v)
                              },
                              expression: "form.returnPeriodBegin"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.EquipmentEstimatedReturnTimeTo"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "31",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.returnPeriodEnd,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "returnPeriodEnd", $$v)
                              },
                              expression: "form.returnPeriodEnd"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "span",
                        { staticClass: "title" },
                        [
                          _vm._v(_vm._s(_vm.$t("SeaExport.PodPortInfo")) + " "),
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "bottom",
                                width: "200",
                                trigger: "hover"
                              }
                            },
                            [
                              _c("div", { staticClass: "pop-content" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_PodPortInfoPrompt")
                                  )
                                )
                              ]),
                              _c("svg-icon", {
                                staticStyle: {
                                  "font-size": "14px",
                                  "margin-top": "-3px"
                                },
                                attrs: {
                                  slot: "reference",
                                  "icon-class": "question"
                                },
                                slot: "reference"
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.EstimatedArrivalTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "32",
                              type: "datetime",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estimatedArrivalTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estimatedArrivalTime", $$v)
                              },
                              expression: "form.estimatedArrivalTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: { label: _vm.$t("SeaExport.ArrivalTime") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "33",
                              type: "datetime",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: { input: _vm.actualArrivalTimeChangeHandler },
                            model: {
                              value: _vm.form.actualArrivalTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualArrivalTime", $$v)
                              },
                              expression: "form.actualArrivalTime"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.isXycw && _vm.showButton
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.CurrentETA") }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "33",
                                  type: "datetime",
                                  disabled:
                                    _vm.editPermissions ||
                                    Boolean(_vm.form.lclMasterUuid),
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.form.currentArrivalTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "currentArrivalTime",
                                      $$v
                                    )
                                  },
                                  expression: "form.currentArrivalTime"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.EstimatedPortDischargeTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "estimatedPortDischargeTime",
                              type: "datetime",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estimatedPortDischargeTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estimatedPortDischargeTime",
                                  $$v
                                )
                              },
                              expression: "form.estimatedPortDischargeTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.PortDischargeTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "34",
                              type: "datetime",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.portDischargeTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "portDischargeTime", $$v)
                              },
                              expression: "form.portDischargeTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.EstimatedRailwayDepartureTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "estimatedRailwayDepartureTime",
                              type: "datetime",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estimatedRailwayDepartureTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estimatedRailwayDepartureTime",
                                  $$v
                                )
                              },
                              expression: "form.estimatedRailwayDepartureTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.RailwayDepartureTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "35",
                              type: "datetime",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.railwayDepartureTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "railwayDepartureTime", $$v)
                              },
                              expression: "form.railwayDepartureTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.EstimatedRailwayDischargeTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "estimatedRailwayDischargeTime",
                              type: "datetime",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estimatedRailwayDischargeTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estimatedRailwayDischargeTime",
                                  $$v
                                )
                              },
                              expression: "form.estimatedRailwayDischargeTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.RailwayDischargeTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "36",
                              type: "datetime",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.railwayDischargeTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "railwayDischargeTime", $$v)
                              },
                              expression: "form.railwayDischargeTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.EstimatedTimeOfArrivalAtThePlaceOfDelivery"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "estimatedArrivalPlaceOfDelivery",
                              type: "datetime",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estimatedArrivalPlaceOfDelivery,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estimatedArrivalPlaceOfDelivery",
                                  $$v
                                )
                              },
                              expression: "form.estimatedArrivalPlaceOfDelivery"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.TheActualTimeOfArrivalAtThePlaceOfDelivery"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "actualArrivalPlaceOfDelivery",
                              type: "datetime",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.actualArrivalPlaceOfDelivery,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "actualArrivalPlaceOfDelivery",
                                  $$v
                                )
                              },
                              expression: "form.actualArrivalPlaceOfDelivery"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.EstimatedCustomsReleaseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "37",
                              type: "datetime",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estimatedCustomsReleaseTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estimatedCustomsReleaseTime",
                                  $$v
                                )
                              },
                              expression: "form.estimatedCustomsReleaseTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.ActualCustomsReleaseTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "38",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.destPortCustomsClearanceTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "destPortCustomsClearanceTime",
                                  $$v
                                )
                              },
                              expression: "form.destPortCustomsClearanceTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.DestinationPortInspection")
                          }
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              no: "38-1",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid)
                            },
                            model: {
                              value: _vm.form.destPortInspection,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "destPortInspection", $$v)
                              },
                              expression: "form.destPortInspection"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.DestinationPortInspectionLevel"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "38-2",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid)
                            },
                            model: {
                              value: _vm.form.destPortInspectionLevel,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "destPortInspectionLevel",
                                  $$v
                                )
                              },
                              expression: "form.destPortInspectionLevel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            title: _vm.$t("SeaExport.PickupMessage"),
                            label: _vm.$t("SeaExport.EstimatedPickupTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "39",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estimatedPickUpTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estimatedPickUpTime", $$v)
                              },
                              expression: "form.estimatedPickUpTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            title: _vm.$t("SeaExport.PickupMessage"),
                            label: _vm.$t("SeaExport.ActualPickUpTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "40",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.actualPickUpTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualPickUpTime", $$v)
                              },
                              expression: "form.actualPickUpTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonlyExcludeExportToImport,
                        "label-width": "110px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.PODDeliveryInformation"))
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.DeliveryToWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.EstimatedDeliveryToWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "41",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estimatedDeliveryToWarehouseTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estimatedDeliveryToWarehouseTime",
                                  $$v
                                )
                              },
                              expression:
                                "form.estimatedDeliveryToWarehouseTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.DeliveryToWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.ActualDeliveryToWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "42",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.deliveryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "deliveryTime", $$v)
                              },
                              expression: "form.deliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.EstimatedDeliveryToCustomersWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.EstimatedDeliveryToCustomersWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "43",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.destPortDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "destPortDeliveryTime", $$v)
                              },
                              expression: "form.destPortDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.ActualDeliveryToCustomersWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.ActualDeliveryToCustomersWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "44",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.deliveryCompletionDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "deliveryCompletionDate",
                                  $$v
                                )
                              },
                              expression: "form.deliveryCompletionDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.isFba
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.EstimatedDeliveryTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "41",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.form.estDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "estDeliveryTime", $$v)
                                  },
                                  expression: "form.estDeliveryTime"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isFba
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ActualDeliveryTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "42",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.form.actDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "actDeliveryTime", $$v)
                                  },
                                  expression: "form.actDeliveryTime"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.EstimatedReturnTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "45",
                              type: "datetime",
                              disabled: _vm.editPermissions,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estimatedReturnTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estimatedReturnTime", $$v)
                              },
                              expression: "form.estimatedReturnTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: { label: _vm.$t("SeaExport.ActualReturnTime") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "46",
                              disabled:
                                _vm.editPermissions ||
                                Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.destPortReturnTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "destPortReturnTime", $$v)
                              },
                              expression: "form.destPortReturnTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.OtherInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CyCode") } },
                        [
                          _c("el-input", {
                            attrs: { no: "47" },
                            model: {
                              value: _vm.form.yardCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "yardCode", $$v)
                              },
                              expression: "form.yardCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortCodeOfDischarge")
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.portCode
                              ? "red-border"
                              : "",
                            attrs: { no: "48" },
                            model: {
                              value: _vm.form.portCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "portCode", $$v)
                              },
                              expression: "form.portCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.EquipmentReceiptAddress")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3, no: "49" },
                            model: {
                              value: _vm.form.addressEIR,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "addressEIR", $$v)
                              },
                              expression: "form.addressEIR"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.EquipmentReceiptContactPerson"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "50" },
                            model: {
                              value: _vm.form.contactEIR,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "contactEIR", $$v)
                              },
                              expression: "form.contactEIR"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.EquipmentReceiptContactWay"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "51" },
                            model: {
                              value: _vm.form.phoneEIR,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "phoneEIR", $$v)
                              },
                              expression: "form.phoneEIR"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.DocCutOffDate") } },
                        [
                          _c("el-date-picker", {
                            class: _vm.importDifferenceField.fileCutoff
                              ? "red-border"
                              : "",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "52",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.fileCutoff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fileCutoff", $$v)
                              },
                              expression: "form.fileCutoff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.DeclareCutOffDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            class: _vm.importDifferenceField.declareCutOff
                              ? "red-border"
                              : "",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "53",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.declareCutOff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "declareCutOff", $$v)
                              },
                              expression: "form.declareCutOff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CYCutOffDate2") } },
                        [
                          _c("el-date-picker", {
                            class: _vm.importDifferenceField.customCutoff
                              ? "red-border"
                              : "",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "54",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.customCutoff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customCutoff", $$v)
                              },
                              expression: "form.customCutoff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomerCyCutOffDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            class: _vm.importDifferenceField.customerCutoff
                              ? "red-border"
                              : "",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "55",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.customerCutoff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerCutoff", $$v)
                              },
                              expression: "form.customerCutoff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomerShutOutDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "56",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.customerShutout,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerShutout", $$v)
                              },
                              expression: "form.customerShutout"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomerClosingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            class: _vm.importDifferenceField.customerFileCutoff
                              ? "red-border"
                              : "",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "56",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.customerFileCutoff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerFileCutoff", $$v)
                              },
                              expression: "form.customerFileCutoff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.ams,
                              expression: "form.ams"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("SeaExport.AmsEnsCyCutOffDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "57",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.amsCutoff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "amsCutoff", $$v)
                              },
                              expression: "form.amsCutoff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "AP CODE" } },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.apCode
                              ? "red-border"
                              : "",
                            attrs: { no: "58" },
                            model: {
                              value: _vm.form.apCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "apCode", $$v)
                              },
                              expression: "form.apCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "AP NAME" } },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.apName
                              ? "red-border"
                              : "",
                            attrs: { no: "59" },
                            model: {
                              value: _vm.form.apName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "apName", $$v)
                              },
                              expression: "form.apName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.FreeDetension") } },
                        [
                          _c("el-input-number", {
                            staticClass: "align-left",
                            staticStyle: { width: "100%" },
                            attrs: { no: "60", controls: false },
                            model: {
                              value: _vm.form.freeTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "freeTime", $$v)
                              },
                              expression: "form.freeTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          attrs: { label: _vm.$t("SeaExport.CargoReadyDate") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "61",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.estimatedPackDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estimatedPackDate", $$v)
                              },
                              expression: "form.estimatedPackDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ArrivalTime2") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "62",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.arrivalTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "arrivalTime", $$v)
                              },
                              expression: "form.arrivalTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showEntrustmentState,
                              expression: "showEntrustmentState"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("SeaExport.ConsignationStatus")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "155px" },
                            attrs: {
                              disabled: true,
                              value: _vm.textEntrustmentState
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.pm.entrustHisBtnClickHandler()
                              }
                            }
                          }),
                          _c(
                            "cargo-button-container",
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "2px" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.entrustHisBtnClickHandler()
                                    }
                                  }
                                },
                                [_vm._v("...")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "form-card",
                      staticStyle: { height: "100%" },
                      attrs: {
                        disabled: _vm.readonlyExcludeExportToImport,
                        "label-width": "130px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.SecondVesselInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.fieldClass.secondVesselVoyageTitle,
                          attrs: { label: _vm.$t("SeaExport.Vessel") }
                        },
                        [
                          _c("el-input", {
                            class: _vm.fieldClass.secondVesselVoyage,
                            attrs: { no: "63" },
                            model: {
                              value: _vm.form.secondVesselVoyage,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondVesselVoyage", $$v)
                              },
                              expression: "form.secondVesselVoyage"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.fieldClass.secondVoyageTitle,
                          attrs: { label: _vm.$t("SeaExport.SecondVoyage") }
                        },
                        [
                          _c("el-input", {
                            class: _vm.fieldClass.secondVoyage,
                            attrs: { no: "64" },
                            model: {
                              value: _vm.form.secondVoyage,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondVoyage", $$v)
                              },
                              expression: "form.secondVoyage"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfDeparture") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "65",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.secondVesselETDChange },
                            model: {
                              value: _vm.form.secondVesselETD,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondVesselETD", $$v)
                              },
                              expression: "form.secondVesselETD"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_SecondPolCode")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            ref: "secondPolCode",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "secondPolCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.secondPolCode,
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.secondPolCode = p.value
                                _vm.form.secondPol = p.englishName
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PortOfLoading")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "secondPol" },
                            model: {
                              value: _vm.form.secondPol,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondPol", $$v)
                              },
                              expression: "form.secondPol"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_SecondPodCode")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            ref: "secondPodCode",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "secondPodCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.secondPodCode,
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.secondPodCode = p.value
                                _vm.form.secondPod = p.englishName
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_DestinationPort")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "secondPod" },
                            model: {
                              value: _vm.form.secondPod,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondPod", $$v)
                              },
                              expression: "form.secondPod"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.SecondArrivalTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "secondArrivalsDate",
                              disabled: _vm.editPermissions,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.secondArrivalsDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondArrivalsDate", $$v)
                              },
                              expression: "form.secondArrivalsDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.SecondUnloadingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "secondUnloadingDate",
                              disabled: _vm.editPermissions,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.secondUnloadingDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondUnloadingDate", $$v)
                              },
                              expression: "form.secondUnloadingDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.SecondLoadingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "secondLoadingDate",
                              disabled: _vm.editPermissions,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.secondLoadingDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondLoadingDate", $$v)
                              },
                              expression: "form.secondLoadingDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.SecondDepartureTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "secondShipmentDate",
                              disabled: _vm.editPermissions,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.secondShipmentDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondShipmentDate", $$v)
                              },
                              expression: "form.secondShipmentDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.TransferModeAtTransferPoint"
                            )
                          }
                        },
                        [
                          _c(
                            "cargo-multi-select",
                            {
                              attrs: {
                                no: "66",
                                disabled: _vm.readonlyExcludeExportToImport
                              },
                              model: {
                                value: _vm.form.fnlTm,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "fnlTm", $$v)
                                },
                                expression: "form.fnlTm"
                              }
                            },
                            _vm._l(_vm.FNL_TM, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.BargeInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.branchLineDateOfDeparture")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.editPermissions,
                              no: "67",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.bargeETD,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeETD", $$v)
                              },
                              expression: "form.bargeETD"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.branchLineDateOfArrival")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.editPermissions,
                              no: "68",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.bargeETA,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeETA", $$v)
                              },
                              expression: "form.bargeETA"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                        [
                          _c("el-input", {
                            attrs: { no: "69" },
                            model: {
                              value: _vm.form.bargeVessel,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeVessel", $$v)
                              },
                              expression: "form.bargeVessel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Voyage") } },
                        [
                          _c("el-input", {
                            attrs: { no: "70" },
                            on: {
                              focus: function($event) {
                                _vm.form.bargeVoyage =
                                  _vm.form.bargeVoyage || "V."
                              }
                            },
                            model: {
                              value: _vm.form.bargeVoyage,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeVoyage", $$v)
                              },
                              expression: "form.bargeVoyage"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.PortOfLoadingPOR") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "71" },
                            model: {
                              value: _vm.form.bargePOL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargePOL", $$v)
                              },
                              expression: "form.bargePOL"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDestination")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "72" },
                            model: {
                              value: _vm.form.bargePOD,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargePOD", $$v)
                              },
                              expression: "form.bargePOD"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ServiceCode") } },
                        [
                          _c("el-input", {
                            attrs: { no: "73" },
                            model: {
                              value: _vm.form.vesselLineCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "vesselLineCode", $$v)
                              },
                              expression: "form.vesselLineCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CYCutOffDate2") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "74",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.form.bargeCustomCutoff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeCustomCutoff", $$v)
                              },
                              expression: "form.bargeCustomCutoff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.RiverCarrier") } },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "75",
                              "method-params": { seaCmp: true },
                              "default-value": _vm.form.riverCarrierId || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.form.riverCarrierId = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "bargeRemarks",
                              type: "textarea",
                              rows: 2
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Remarks"),
                                  _vm.form.bargeRemarks,
                                  function(val) {
                                    _vm.form.bargeRemarks = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.bargeRemarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeRemarks", $$v)
                              },
                              expression: "form.bargeRemarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.enableShipperConsignNotify
                ? _c(
                    "div",
                    { staticClass: "section form-column" },
                    [
                      _c(
                        "el-form",
                        {
                          staticStyle: { height: "100%" },
                          attrs: {
                            disabled: _vm.readonlyExcludeExportToImport,
                            "label-width": "70px",
                            "label-position": "right"
                          }
                        },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SeaExport.ConsigneeShipperAndNotifyInfo"
                                )
                              )
                            )
                          ]),
                          _c("el-form-item", { staticClass: "auto-width" }, [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Shipper")))]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: { display: "flex", width: "100%" }
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  ref: "shipperCode",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled: _vm.enableShipperLocked,
                                    no: "shipperCode"
                                  },
                                  model: {
                                    value: _vm.mblCargoDoc.shipperCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mblCargoDoc,
                                        "shipperCode",
                                        $$v
                                      )
                                    },
                                    expression: "mblCargoDoc.shipperCode"
                                  }
                                }),
                                _c("cargo-advance-select", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    no: "shipperId",
                                    disabled: _vm.enableShipperLocked,
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Company,
                                    "method-params": {
                                      shipper: true,
                                      active: true
                                    },
                                    filterable: "",
                                    "default-value":
                                      _vm.mblCargoDoc.shipperId || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.pm.shipperAutoCompleteChange(p)
                                    }
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "reset",
                                      disabled: _vm.enableShipperLocked,
                                      type: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(1)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.Reset")) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._l(7, function(count) {
                            return _c(
                              "el-form-item",
                              {
                                key: "shipperLine" + count,
                                staticClass: "auto-width"
                              },
                              [
                                _c(
                                  "special-character-tip",
                                  {
                                    attrs: {
                                      texts:
                                        _vm.specialCharCheck[
                                          "shipperLine" + count
                                        ]
                                    }
                                  },
                                  [
                                    _c("cargo-input", {
                                      ref: "shipperLine" + count,
                                      refInFor: true,
                                      attrs: {
                                        disabled: _vm.enableShipperLocked,
                                        no: "shipperLine" + count,
                                        "auto-uppercase":
                                          _vm.notUppercaseShipperConsigneNotify
                                      },
                                      on: {
                                        change: function() {
                                          return _vm.wrapAddr(
                                            _vm.mblCargoDoc,
                                            "shipperLine" + count,
                                            count + 1 > 7
                                              ? null
                                              : "shipperLine" + (count + 1),
                                            _vm.maxChars
                                          )
                                        }
                                      },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          return _vm.showShipperDialog($event)
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.mblCargoDoc[
                                            "shipperLine" + count
                                          ],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mblCargoDoc,
                                            "shipperLine" + count,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mblCargoDoc['shipperLine'+count]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _c("el-form-item", { staticClass: "auto-width" }, [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Consignee")))]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: { display: "flex", width: "100%" }
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  ref: "consigneeCode",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled: _vm.enableShipperLocked,
                                    no: "19"
                                  },
                                  model: {
                                    value: _vm.mblCargoDoc.consigneeCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mblCargoDoc,
                                        "consigneeCode",
                                        $$v
                                      )
                                    },
                                    expression: "mblCargoDoc.consigneeCode"
                                  }
                                }),
                                _c("cargo-advance-select", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    no: "consigneeId",
                                    disabled: _vm.enableShipperLocked,
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Company,
                                    "method-params": {
                                      consignee: true,
                                      active: true
                                    },
                                    filterable: "",
                                    "default-value":
                                      _vm.mblCargoDoc.consigneeId || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.pm.consigneeAutoCompleteChange(p)
                                    }
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "reset",
                                      type: "primary",
                                      disabled: _vm.enableShipperLocked
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(2)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.Reset")) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._l(7, function(count) {
                            return _c(
                              "el-form-item",
                              {
                                key: "consigneeLine" + count,
                                staticClass: "auto-width"
                              },
                              [
                                _c(
                                  "special-character-tip",
                                  {
                                    attrs: {
                                      texts:
                                        _vm.specialCharCheck[
                                          "consigneeLine" + count
                                        ]
                                    }
                                  },
                                  [
                                    _c("cargo-input", {
                                      ref: "consigneeLine" + count,
                                      refInFor: true,
                                      attrs: {
                                        disabled: _vm.enableShipperLocked,
                                        no: "consigneeLine" + count,
                                        "auto-uppercase":
                                          _vm.notUppercaseShipperConsigneNotify
                                      },
                                      on: {
                                        change: function() {
                                          return _vm.wrapAddr(
                                            _vm.mblCargoDoc,
                                            "consigneeLine" + count,
                                            count + 1 > 7
                                              ? null
                                              : "consigneeLine" + (count + 1),
                                            _vm.maxChars
                                          )
                                        }
                                      },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          return _vm.showConsigneeDialog($event)
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.mblCargoDoc[
                                            "consigneeLine" + count
                                          ],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mblCargoDoc,
                                            "consigneeLine" + count,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mblCargoDoc['consigneeLine'+count]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _c("el-form-item", { staticClass: "auto-width" }, [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.NotifyParty")))]
                            ),
                            _c(
                              "div",
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  ref: "notifyCode",
                                  attrs: {
                                    disabled: _vm.enableShipperLocked,
                                    no: "notifyCode"
                                  },
                                  model: {
                                    value: _vm.mblCargoDoc.notifyCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mblCargoDoc,
                                        "notifyCode",
                                        $$v
                                      )
                                    },
                                    expression: "mblCargoDoc.notifyCode"
                                  }
                                }),
                                _c("cargo-advance-select", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  attrs: {
                                    no: "notifyId",
                                    disabled: _vm.enableShipperLocked,
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Company,
                                    "method-params": {
                                      notify: true,
                                      active: true
                                    },
                                    filterable: "",
                                    "default-value":
                                      _vm.mblCargoDoc.notifyId || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.pm.notifyAutoCompleteChange(p)
                                    }
                                  }
                                }),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-top": "5px" } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "reset",
                                          type: "primary",
                                          disabled: _vm.enableShipperLocked
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.pm.onClear(3)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Reset")) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-left": "5px" },
                                        attrs: {
                                          no: "copyConsignee",
                                          type: "primary",
                                          disabled: _vm.enableShipperLocked
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.pm.onCopyConsignee()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.CopyTheConsignee")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._l(7, function(count) {
                            return _c(
                              "el-form-item",
                              {
                                key: "notifyLine" + count,
                                staticClass: "auto-width"
                              },
                              [
                                _c(
                                  "special-character-tip",
                                  {
                                    attrs: {
                                      texts:
                                        _vm.specialCharCheck[
                                          "notifyLine" + count
                                        ]
                                    }
                                  },
                                  [
                                    _c("cargo-input", {
                                      ref: "notifyLine" + count,
                                      refInFor: true,
                                      attrs: {
                                        no: "notifyLine" + count,
                                        disabled: _vm.enableShipperLocked,
                                        "auto-uppercase":
                                          _vm.notUppercaseShipperConsigneNotify
                                      },
                                      on: {
                                        change: function() {
                                          return _vm.wrapAddr(
                                            _vm.mblCargoDoc,
                                            "notifyLine" + count,
                                            count + 1 > 7
                                              ? null
                                              : "notifyLine" + (count + 1),
                                            _vm.maxChars
                                          )
                                        }
                                      },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          return _vm.showNotifyDialog($event)
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.mblCargoDoc["notifyLine" + count],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mblCargoDoc,
                                            "notifyLine" + count,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mblCargoDoc['notifyLine'+count]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c(
              "div",
              { staticClass: "section", staticStyle: { width: "100%" } },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.ModulesInfo")))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "form-row",
                    staticStyle: { display: "flex", "flex-direction": "row" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonlyExcludeExportToImport,
                          inline: true,
                          "label-width": "160px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.ShippingAdviceRemark")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "395px" },
                              attrs: { no: "76", type: "textarea", rows: 5 },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.ShippingAdviceRemark"),
                                    _vm.form.remarksShipping,
                                    function(val) {
                                      _vm.form.remarksShipping = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form.remarksShipping,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "remarksShipping", $$v)
                                },
                                expression: "form.remarksShipping"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SeaExport.BookingConfirmationRemarks"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "395px" },
                              attrs: { no: "77", type: "textarea", rows: 5 },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t(
                                      "SeaExport.BookingConfirmationRemarks"
                                    ),
                                    _vm.form.remarksBooking,
                                    function(val) {
                                      _vm.form.remarksBooking = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form.remarksBooking,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "remarksBooking", $$v)
                                },
                                expression: "form.remarksBooking"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm.isTP
              ? _c(
                  "div",
                  { staticClass: "section", staticStyle: { width: "100%" } },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_MultiLegVoyageManagement")
                        )
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "form-row",
                        staticStyle: { "flex-direction": "row" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "padding-bottom": "5px"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "add",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: { click: _vm.addClickHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Add")) + " "
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "delete",
                                  type: "danger",
                                  disabled: _vm.readonly
                                },
                                on: { click: _vm.deleteClickHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Delete")) + " "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c("cargo-ag-grid", {
                          attrs: {
                            "show-side-bar": false,
                            "grid-options": _vm.leg.gridOptions,
                            "column-defs": _vm.columnDefs,
                            "grid-style": "height:100%;",
                            "row-data": _vm.leg.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              return (_vm.leg.gridApi = params.api)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm.ediReceipt.showEdiReceipt
              ? _c(
                  "div",
                  { staticClass: "section" },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.BookingReceipt")) +
                          " (" +
                          _vm._s(_vm.$t("SeaExport.InMailOfThePrevail")) +
                          ")"
                      )
                    ]),
                    _c("booking-confirmation", {
                      attrs: {
                        "edi-receipt-data": _vm.ediReceipt.data,
                        "job-no": _vm.pm.job.jobNo
                      },
                      on: { syncBC: _vm.syncBC }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.ediReceiptCommon.showEdiReceipt
              ? _c(
                  "div",
                  { staticClass: "section" },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.BookingReceipt")))
                    ]),
                    _c("booking-confirmation-common", {
                      attrs: {
                        "edi-receipt-data": _vm.ediReceiptCommon.data,
                        "job-no": _vm.pm.job.jobNo,
                        job: _vm.pm.job,
                        "last-receipt-time": _vm.ediReceiptCommon.data[0].time
                      },
                      on: {
                        showYdBookingResult: function($event) {
                          return _vm.$emit("showYdBookingResult", "tabVesselEq")
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("input", {
            ref: "importFile",
            staticStyle: { display: "none" },
            attrs: { type: "file", accept: ".pms" },
            on: { change: _vm.onImportFile }
          }),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.readonlyExcludeExportToImport,
                  type: "textarea",
                  rows: "10"
                },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEditExcludeExportToImport,
                          expression: "isEditExcludeExportToImport"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.transAdvanceTextDialog.visible,
                title: _vm.transAdvanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.transAdvanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("el-input", {
                attrs: {
                  disabled:
                    _vm.readonlyExcludeExportToImport ||
                    _vm.enableShipperLocked,
                  type: "textarea",
                  rows: "10"
                },
                model: {
                  value: _vm.transAdvanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.transAdvanceTextDialog, "value", $$v)
                  },
                  expression: "transAdvanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEditExcludeExportToImport,
                          expression: "isEditExcludeExportToImport"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.finishTransAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.transAdvanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("SeaExport.tips"),
                visible: _vm.vesseldialog,
                width: "30%",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.vesseldialog = $event
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "text-indent": "2em",
                    "font-size": "14px",
                    "line-height": "1.5",
                    "letter-spacing": "0.5px"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.ObtainedContainerAndGoodsData")) +
                      " "
                  ),
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-size": "14px" } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Message.ShipName")) +
                          _vm._s(
                            _vm.jobDataVessel
                              ? _vm.jobDataVessel
                              : _vm.$t("SeaExport.empty")
                          ) +
                          "、" +
                          _vm._s(_vm.$t("SeaExport.Sailing")) +
                          _vm._s(
                            _vm.jobDataVoyageFlight
                              ? _vm.jobDataVoyageFlight
                              : _vm.$t("SeaExport.empty")
                          )
                      )
                    ]
                  ),
                  _vm._v(_vm._s(_vm.$t("SeaExport.WithBookingTab")) + " "),
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-size": "14px" } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Message.ShipName")) +
                          _vm._s(
                            _vm.shippingDate.vessel
                              ? _vm.shippingDate.vessel
                              : _vm.$t("SeaExport.empty")
                          ) +
                          "、" +
                          _vm._s(_vm.$t("SeaExport.Sailing")) +
                          _vm._s(
                            _vm.shippingDate.voyageFlight
                              ? _vm.shippingDate.voyageFlight
                              : _vm.$t("SeaExport.empty")
                          )
                      )
                    ]
                  ),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("SeaExport.InconsistentFromTheBillData")) +
                      " "
                  ),
                  _c("br"),
                  _c("span", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("SeaExport.InconsistentFromTheBillDataTips")
                      )
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.changeVessel("empty")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.importEmpty")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.changeVessel("notEmpty")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.importNotEmpty")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.changeVessel("ignore")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ignore")))]
                  )
                ],
                1
              )
            ]
          ),
          _c("cross-tenant-history-dialog", {
            attrs: {
              visible: _vm.crossTenantHistoryDialog.visible,
              "entrustment-type": _vm.crossTenantHistoryDialog.entrustmentType,
              "job-no": _vm.crossTenantHistoryDialog.jobNo
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.crossTenantHistoryDialog, "visible", $event)
              }
            }
          }),
          _c("api-popup", {
            attrs: {
              visible: _vm.apiPopup.visible,
              title: _vm.apiPopup.title,
              "interface-type": _vm.apiPopup.interfaceType,
              "interface-array": _vm.apiPopup.interfaceArray,
              "is-hz": _vm.isHZ
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.apiPopup, "visible", $event)
              },
              selectedApi: _vm.selectedApiCallback
            }
          }),
          _c("error-log-dialog", {
            attrs: {
              visible: _vm.errorLogDialog.visible,
              "error-log": _vm.errorLogDialog.errorLog
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.errorLogDialog, "visible", $event)
              }
            }
          }),
          _c("dialog-selector", {
            attrs: {
              visible: _vm.selectorDialog.visible,
              title: _vm.selectorDialog.title,
              "row-data": _vm.selectorDialog.rowData
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.selectorDialog, "visible", $event)
              },
              selected: _vm.getEDICallback
            }
          }),
          _c("message-preview-dialog", {
            attrs: {
              visible: _vm.messagePreviewDialog.visible,
              params: _vm.messagePreviewDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.messagePreviewDialog, "visible", $event)
              },
              uploadSuccess: _vm.uploadSuccessHandler
            }
          }),
          _c("multi-seg-num-rules-dialog", {
            attrs: { visible: _vm.multiSegNumRulesDialog.visible },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.multiSegNumRulesDialog, "visible", $event)
              },
              callback: _vm.multiSegNumRulesCallback
            }
          }),
          _c("generate-mbl-no-dialog", {
            attrs: {
              visible: _vm.mblConfig.visible,
              form: _vm.form,
              config: _vm.mblConfig
            },
            on: {
              close: function($event) {
                _vm.mblConfig.visible = false
              }
            }
          }),
          _c("generate-so-no-dialog", {
            attrs: {
              visible: _vm.soNoConfig.visible,
              form: _vm.form,
              config: _vm.soNoConfig,
              "input-mbl": _vm.isInputMbl,
              "mbl-config": _vm.mblConfig
            },
            on: {
              close: function($event) {
                _vm.soNoConfig.visible = false
              }
            }
          }),
          _vm.ediBaseWindow.visible
            ? _c("edi-guide-window", {
                ref: "ediBaseWindow",
                attrs: {
                  "do-saving": _vm.doSaving,
                  "global-var": _vm.globalVar,
                  visible: _vm.ediBaseWindow.visible,
                  "call-back-func": _vm.ediBaseWindow.callBackFunc,
                  context: _vm.context
                },
                on: {
                  close: function($event) {
                    _vm.ediBaseWindow.visible = false
                  },
                  ediChangeHandler: _vm.ediChangeHandler
                }
              })
            : _vm._e(),
          _vm.bookingLogDialog.visible
            ? _c("booking-log-dialog", {
                attrs: {
                  visible: _vm.bookingLogDialog.visible,
                  "job-uuid": _vm.bookingLogDialog.jobUuid,
                  "send-type": _vm.bookingLogDialog.sendType,
                  "is-hz": _vm.isHZ
                },
                on: {
                  close: function($event) {
                    _vm.bookingLogDialog.visible = false
                  }
                }
              })
            : _vm._e(),
          _vm.showMoreShippingSchedule
            ? _c("choose-shipping-schedules", {
                attrs: {
                  visible: _vm.showMoreShippingSchedule,
                  job: _vm.form,
                  "shipping-schedules": _vm.shippingSchedules,
                  "choose-shipping-schedule": _vm.chooseShippingSchedule,
                  "is-btn": _vm.isChooseShippingScheduleBtn
                },
                on: { close: _vm.closeMoreShippingScheduleDialog }
              })
            : _vm._e(),
          _c("shipping-schedule-dialog", {
            ref: "voyageShowDialog",
            attrs: {
              visible: _vm.voyageShowDialog,
              callback: _vm.callbackShippingScheduleHanle
            },
            on: {
              "update:visible": function($event) {
                _vm.voyageShowDialog = $event
              }
            }
          }),
          _vm.checkingWindow.visible
            ? _c("checking-window", {
                attrs: {
                  visible: _vm.checkingWindow.visible,
                  lob: _vm.form.lob,
                  job: _vm.form,
                  "check-node": _vm.checkingWindow.checkNode,
                  "call-back": _vm.checkingWindow.callBack
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.checkingWindow, "visible", $event)
                  }
                }
              })
            : _vm._e(),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.showRouteDialog,
                title: this.$t("common.btn.confirm"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.showRouteDialog = $event
                }
              }
            },
            [
              _c("div", { staticStyle: { "margin-bottom": "16px" } }, [
                _vm._v(_vm._s(this.routeTitle))
              ]),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.selectedRoute,
                    callback: function($$v) {
                      _vm.selectedRoute = $$v
                    },
                    expression: "selectedRoute"
                  }
                },
                _vm._l(_vm.routeOptions, function(item) {
                  return _c("el-radio", { key: item, attrs: { label: item } }, [
                    _vm._v(_vm._s(item))
                  ])
                }),
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onRouteDialogConfirm }
                    },
                    [_vm._v(_vm._s(this.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.showRouteDialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(this.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }